// Per-user ("legacy") manager permissions live in users.manager_permissions and
// are only honoured by the server for a manager with NO role_id — anyone with a
// role_id gets the role's permissions (buildPermissions in server/middleware/auth.js).
export function usesLegacyManagerPermissions(person) {
  return person?.user_role === 'manager' && !person?.user_role_id;
}

// Switch list for the Manage Employees dialog. Keys come from the server's GET
// /auth/users/:id/permissions response (exactly DEFAULT_MANAGER_PERMISSIONS), so
// the dialog can never drift from what the server lets you save. Labels and
// descriptions come from the permission registry (GET /roles/permissions).
// Order: registry order first, then any key the registry lacks (label = key).
export function legacyPermissionToggles(managerPerms, registry) {
  if (!managerPerms) return [];
  const reg = registry || {};
  const keys = Object.keys(managerPerms).filter((k) => k.startsWith('can_'));
  const known = Object.keys(reg).filter((k) => keys.includes(k));
  const unknown = keys.filter((k) => !reg[k]);
  return [...known, ...unknown].map((key) => ({
    key,
    label: reg[key]?.label || key,
    description: reg[key]?.description || '',
  }));
}
